// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "views/root/components/Footer";

// Soft UI Dashboard PRO React page layout routes

function EmptyLayout({ children }) {
  return (
    <PageLayout background="white">
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mx: "auto" }}>
          <SoftBox p={3}>{children}</SoftBox>
        </Grid>
      </Grid>
      <SoftBox mt={8}>
        <Footer />
      </SoftBox>
    </PageLayout>
  );
}

// Setting default values for the props of IllustrationLayout
EmptyLayout.defaultProps = {
  color: "info",
  header: "",
  title: "",
  description: "",
  illustration: {},
};

// Typechecking props for the IllustrationLayout
EmptyLayout.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default EmptyLayout;
